<template>
  <v-app>
    <div class="card card-custom">
      <div class="card-body p-0">
        <div
            class="wizard wizard-2"
            id="kt_wizard_v2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
        >
          <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-sm-12">
                <h4>Manage Quiz
                </h4>
                <router-link :to="{ name: 'dashboard' }">
                  Dashboard
                </router-link>
                \
                Quiz
              </div>
              <!--                        <div class="col-4">-->
              <!--                            <h4>Manage Institution</h4>-->
              <!--                        </div>-->
              <div class="col-md-6 col-lg-6 col-sm-12 text-right">
                <a @click.prevent="addNewQuiz" class="btn btn-primary ml-2">
                  Add Quiz
                </a>
              </div>

            </div>
            <div class="row">
              <div class="col-12">
                <v-data-table
                    hide-default-footer
                    :headers="headers"
                    :items="quizes"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    item-key="name"
                    show-expand
                    class="elevation-1"
                    :items-per-page="perPage"
                >
                  <template v-slot:item.title="{ headers, item }">
                    <a class="menu-link" @click.prevent="__editQuiz(item.id)">
                      {{ item.title }}
                    </a>
                    <i class="fas fa-circle"
                       :class="item.is_active?'dot-active':'dot-inactive'"></i>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-row>
                        <v-col cols="2">
                          Scheduled at : {{ item.schedule_at }}
                        </v-col>
                        <v-col cols="2">
                          Start time : {{ item.start_time }}
                        </v-col>
                        <v-col cols="2">
                          End time : {{ item.end_time }}
                        </v-col>
                        <v-col cols="2">
                          Question Order : {{ item.question_order }}
                        </v-col>
                        <v-col cols="2">
                          Answer Order : {{ item.answer_order }}
                        </v-col>
                        <v-col cols="2">
                          Time Per Question : {{ item.time_length }}
                        </v-col>
                        <v-col cols="2">
                          Display Per Page : {{ item.display_per_page }}
                        </v-col>
                        <v-col cols="2">
                          No. of Attempt Allowed : {{ item.no_of_attempts_allowed }}
                        </v-col>
                        <v-col cols="2">
                          Enable Feedback : <span class="badge"
                                                  :class="item.feedback_enable?'badge-success':'badge-danger'">
                                                                             {{ item.feedback_enable ? 'Yes' : 'No' }}
                                                                          </span>

                        </v-col>
                        <v-col cols="2">
                          Display Result : <span class="badge"
                                                 :class="item.display_result?'badge-success':'badge-danger'">
                                                                             {{ item.display_result ? 'Yes' : 'No' }}
                                                                          </span>
                        </v-col>
                        <v-col cols="2">
                          Pausable : <span class="badge"
                                           :class="item.is_pausable?'badge-success':'badge-danger'">
                                                                             {{ item.is_pausable ? 'Yes' : 'No' }}
                                                                </span>
                        </v-col>
                        <v-col cols="2">
                          Active : <span class="badge"
                                         :class="item.is_active?'badge-success':'badge-danger'">
                                                                             {{
                            item.is_active ? 'Active' : 'Inactive'
                          }}
                                                                </span>
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:item.action="{ headers, item }">
                    <b-dropdown
                        size="sm"
                        variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        no-caret
                        right
                        no-flip
                    >
                      <template v-slot:button-content>
                        <slot>
                                                        <span>
                                                                    <i class="flaticon-more-1"></i>
                                                                  </span></slot>
                      </template>
                      <!--begin::Navigation-->
                      <div class="navi navi-hover ">

                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" @click.prevent="viewResult(item.id)" class="navi-link"
                          >
                                                                            <span class="navi-icon">
                                                                              <i class="fas fa-eye"></i>
                                                                            </span>
                            <span class="navi-text">  View Result</span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" @click.prevent="_calculateResult(item.id)" class="navi-link"
                          >
                                                                            <span class="navi-icon">
                                                                              <i class="fas fa-calculator"></i>
                                                                            </span>
                            <span class="navi-text">  Calculate Result</span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" @click.prevent="__editQuiz(item.id)" class="navi-link"
                          >
                                                                            <span class="navi-icon">
                                                                              <i class="flaticon-edit"></i>
                                                                            </span>
                            <span class="navi-text">  Edit</span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" @click.prevent="__deleteQuiz(item.id)" class="navi-link"
                          >
                                                                                <span class="navi-icon">
                                                                                  <i class="fas fa-trash"></i>
                                                                                </span>
                            <span class="navi-text">  Delete</span>
                          </a>
                        </b-dropdown-text>

                      </div>
                      <!--end::Navigation-->
                    </b-dropdown>
                  </template>
                </v-data-table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-quiz :dialog="dialog" @close-dialog="cancelQuizDialog"></add-quiz>

  </v-app>
</template>
<script>

import {QuizMixin} from "@/mixins/QuizMixin";
import {required} from "vuelidate/lib/validators";


import AddQuiz from "@/view/pages/quiz/Dialog/AddQuiz";

export default {
  name: "QuestionBanks",
  mixins: [QuizMixin],
  components: {
    AddQuiz
  },
  data() {
    return {
      dialog: false,

      expanded: [],
      assignedTeacherCourseList: [],
      singleExpand: true,
      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {text: 'Program', value: 'program.title'},
        {text: 'Action', value: 'action'},
      ],
      quizes: [],
    }
  },
  mounted() {
    this.__getQuiz();
  },
  methods: {
    addNewQuiz() {
      this.dialog = true;
    },
    cancelQuizDialog() {
      this.resetForm()
      this.dialog = false;
      this.__getQuiz()
    },
    __editQuiz(id) {
      this.$router.push({name: 'quiz-update', params: {quiz_id: id}})
    },
    __deleteQuiz(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.deleteQuiz(id);
          }
        }
      });
    },

    _calculateResult(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.calculateResult(id);
          }
        }
      });
    },
    viewResult(id) {
      this.$router.push({name: 'quiz-result', params: {id: id}})
    },



  }
};
</script>
